export const resources = {
  SidebarUserAlerts: '',
  SidebarUserMessages: '',
  SidebarUserClear: '',
  SidebarNotificationsEmptyTitle: '',
  SidebarNotificationsEmptySubtitle: ''
};
